import type { WaterInvoiceModel } from '@/core/models/water-invoice.model';
import type { CreateInvoicePayload } from '@/core/repos/tables/water-invoice.repo';

export interface InvoicePreviewState {
    revision: number;
    loading: boolean;
    invoice?: WaterInvoiceModel;
    payload?: CreateInvoicePayload;
    manual?: boolean;
}

export type InvoicePreviewAction =
    | { type: 'start' }
    | { type: 'invalidate' }
    | { type: 'failure'; revision: number }
    | { type: 'success'; revision: number; invoice: WaterInvoiceModel; payload: CreateInvoicePayload; manual: boolean };

export const initialInvoicePreview: InvoicePreviewState = { revision: 0, loading: false };

/** Each edit or request retires all earlier asynchronous preview results. */
export function invoicePreviewReducer(state: InvoicePreviewState, action: InvoicePreviewAction): InvoicePreviewState {
    if (action.type === 'invalidate' || action.type === 'start') {
        return { revision: state.revision + 1, loading: action.type === 'start' };
    }
    if (action.revision !== state.revision) return state;
    if (action.type === 'failure') return { revision: state.revision, loading: false };
    if (action.type === 'success') {
        // Never inherit a fingerprint passed into a previous request.
        const { previewFingerprint, ...payload } = action.payload;
        return { revision: state.revision, loading: false, invoice: action.invoice, payload, manual: action.manual };
    }
    return state;
}

export function getInvoiceSavePayload(state: InvoicePreviewState): CreateInvoicePayload | undefined {
    if (state.loading || !state.invoice || !state.payload) return undefined;
    if (!state.manual) return { ...state.payload };
    const hash = state.invoice.resellerCalculationHash;
    if ((state.invoice.resellerPricingMode || state.invoice.resellerSummary?.hasResellerDiscount || state.invoice.resellerPolicyId) && !hash) return undefined;
    return hash ? { ...state.payload, previewFingerprint: hash } : { ...state.payload };
}
